var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-misc"},[_c('b-row',{staticClass:"w-100 m-0"},[_c('b-col',{staticClass:"d-flex justify-content-center",attrs:{"lg":"12"}},[_c('div',{staticClass:"page-misc-view"},[_c('img',{attrs:{"src":_vm.logoImg,"alt":"Lalak"}}),_c('div',{staticClass:"page-misc-card"},[_vm._t("default")],2)])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }